import { render, staticRenderFns } from "./AgentCard.vue?vue&type=template&id=e89857c6&scoped=true"
import script from "./AgentCard.vue?vue&type=script&lang=js"
export * from "./AgentCard.vue?vue&type=script&lang=js"
import style0 from "./AgentCard.vue?vue&type=style&index=0&id=e89857c6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e89857c6",
  null
  
)

export default component.exports